// extracted by mini-css-extract-plugin
export default {"mainContainer":"TopToPage_mainContainer__SzfhK","icon":"TopToPage_icon__sA8ZT"};